// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media print, screen and (min-width: 62.625em){.item_separator-module__separator--YdUpO{display:none}}@media screen and (max-width: 62.5625em){.item_separator-module__separator--YdUpO{float:left;display:inline-block;border:0;width:105.2%;margin-left:-2.6%;height:1px;background-color:#616161;margin-top:16px;margin-bottom:24px}}\n", ""]);
// Exports
exports.locals = {
	"separator": "item_separator-module__separator--YdUpO"
};
module.exports = exports;
